import React from "react";

export default function Footer() {
  return (
    <p className="closer">
      This project was coded by{" "}
      <a href="mailto:thekalwhite@gmail.com">Katie White</a> and is open-sourced
      on{" "}
      <a
        href="https://github.com/TheKatieWhite/weather-react-project"
        target="_blank"
        rel="noreferrer"
      >
        github.com{" "}
      </a>
      and hosted on{" "}
      <a href="https://www.netlify.com" target="_blank" rel="noreferrer">
        Netlify.com
      </a>
      .
    </p>
  );
}
